import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminTelecomRates() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/telecom/rates").then(({ data }) => setCfg(data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const setRow = (i, field, val) => setCfg((c) => {
    const rate_card = c.rate_card.map((r, idx) => idx === i ? { ...r, [field]: field === "cost_cpm_cents" ? Number(val) : val } : r);
    return { ...c, rate_card };
  });
  const addRow = () => setCfg((c) => ({ ...c, rate_card: [...c.rate_card, { label: "", prefix: "", cost_cpm_cents: 0 }] }));
  const delRow = (i) => setCfg((c) => ({ ...c, rate_card: c.rate_card.filter((_, idx) => idx !== i) }));

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/telecom/rates", { margin_pct: Number(cfg.margin_pct), rate_card: cfg.rate_card });
      setCfg(data); toast.success("Rates saved");
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  if (!cfg) return <div className="p-6 text-sm text-muted-foreground">Loading rates…</div>;
  const price = (cost) => (Number(cost) * (1 + Number(cfg.margin_pct) / 100)).toFixed(2);

  return (
    <div className="mx-auto max-w-3xl space-y-6" data-testid="admin-telecom-rates">
      <div>
        <h1 className="font-display text-2xl font-semibold">Telecom Overage Rates</h1>
        <p className="mt-1 text-sm text-muted-foreground">Set your Telnyx cost per minute; the customer is billed cost + margin from their Wallet once they exceed plan minutes / world credit.</p>
      </div>

      <div className="rounded-2xl border border-border bg-card p-5">
        <label className="text-sm font-semibold">Profit margin (%)</label>
        <p className="text-xs text-muted-foreground">200% = charge 3× your cost. Applies to every destination.</p>
        <input data-testid="margin-input" type="number" min="0" step="10" value={cfg.margin_pct}
          onChange={(e) => setCfg((c) => ({ ...c, margin_pct: e.target.value }))}
          className="mt-2 w-40 rounded-lg border border-input bg-background px-3 py-2 text-sm" />
      </div>

      <div className="rounded-2xl border border-border bg-card p-5">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="font-semibold">Rate card (¢ / minute)</h2>
          <button onClick={addRow} data-testid="add-rate" className="rounded-lg border border-border px-3 py-1.5 text-xs font-semibold">+ Add</button>
        </div>
        <div className="space-y-2">
          <div className="grid grid-cols-12 gap-2 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
            <span className="col-span-4">Label</span><span className="col-span-3">Prefix</span><span className="col-span-2">Cost ¢</span><span className="col-span-2">Billed ¢</span><span className="col-span-1" />
          </div>
          {cfg.rate_card.map((r, i) => (
            <div key={i} className="grid grid-cols-12 items-center gap-2">
              <input value={r.label} onChange={(e) => setRow(i, "label", e.target.value)} className="col-span-4 rounded-lg border border-input bg-background px-2 py-1.5 text-sm" />
              <input value={r.prefix} onChange={(e) => setRow(i, "prefix", e.target.value)} placeholder="+1" className="col-span-3 rounded-lg border border-input bg-background px-2 py-1.5 font-mono-metric text-sm" />
              <input type="number" step="0.1" value={r.cost_cpm_cents} onChange={(e) => setRow(i, "cost_cpm_cents", e.target.value)} className="col-span-2 rounded-lg border border-input bg-background px-2 py-1.5 text-sm" />
              <span className="col-span-2 font-mono-metric text-sm text-emerald-500">{price(r.cost_cpm_cents)}</span>
              <button onClick={() => delRow(i)} className="col-span-1 text-xs text-red-400">✕</button>
            </div>
          ))}
        </div>
      </div>

      <button onClick={save} disabled={saving} data-testid="save-rates" className="rounded-full bg-primary px-6 py-3 text-sm font-bold text-primary-foreground disabled:opacity-60">
        {saving ? "Saving…" : "Save rates"}
      </button>
    </div>
  );
}
